module Meevo.Components.Controls {
    declare let d3: any;
    import IDashboardGoalsGraphsLogic = Meevo.Plugins.DashboardGoals.IDashboardGoalsGraphsLogic;
    import GoalCategoryEnum = Meevo.Components.Goals.GoalCategoryEnum;

    class MeevoGoalsAverageTicketChartsComponent implements angular.IComponentController {

        static $inject = ['$scope', 'meevo.plugins.docsAndForms.DashboardGoalsGraphsLogic'];
        public goalDecimal: number;
        public actualDecimal: number;
        public chartClass: string;
        public parent: any;
        public goal: number;
        public actual: number;
        public dashboardGoalsGraphsLogic: IDashboardGoalsGraphsLogic;
        public overallGoal: number;
        public retailGoal: number;
        public serviceGoal: number;
        public currentGoalsModel: any;
        private averageTicketOverallCat: GoalCategoryEnum = GoalCategoryEnum.AverageTicket;
        private averageTicketServiceCat: GoalCategoryEnum = GoalCategoryEnum.AverageServiceTicket;
        private averageTicketRetailCat: GoalCategoryEnum = GoalCategoryEnum.AverageRetailTicket;
        private selectedDateRange: number;

        private averageTicketOverallGoal: number;
        private averageTicketOverallActual: number;

        private averageTicketRetailGoal: number;
        private averageTicketRetailActual: number;

        private averageTicketServiceGoal: number;
        private averageTicketServiceActual: number;

        constructor(private $scope: ng.IScope) { }


        $onInit = () => {
            
            this.$scope.$watch(() => this.parent.currentGoalsModel, (value) => {

                if (!value) return;

                this.currentGoalsModel = this.parent.currentGoalsModel;
                this.goalDecimal = this.parent.goal;
                this.actualDecimal = this.parent.actual;
                this.selectedDateRange = this.parent.selectedDateRange.value;
                this.drawCharts();
            });

            this.$scope.$watch(() => this.parent.selectedDateRange, (dateRange) => {

                if (!dateRange || !this.currentGoalsModel) return;
                
                this.selectedDateRange = dateRange.value;
                this.drawCharts();
                
            });
            
        }

        drawCharts() {
            var averageOverallTicketItem = _.find(this.currentGoalsModel["averageTicket"], (item: any) => { return (this.selectedDateRange == item.dateRangeEnum && item.goalCategory == this.averageTicketOverallCat) });
            var averageServiceTicketItem = _.find(this.currentGoalsModel["averageTicket"], (item: any) => { return this.selectedDateRange == item.dateRangeEnum && item.goalCategory == this.averageTicketServiceCat });
            var averageRetailTicketItem = _.find(this.currentGoalsModel["averageTicket"], (item: any) => { return this.selectedDateRange == item.dateRangeEnum && item.goalCategory == this.averageTicketRetailCat });
            

            this.averageTicketOverallActual = averageOverallTicketItem ? averageOverallTicketItem.actualAmount : 0;
            this.averageTicketOverallGoal = averageOverallTicketItem ? averageOverallTicketItem.amount : 0;

            this.averageTicketRetailActual = averageRetailTicketItem ? averageRetailTicketItem.actualAmount : 0;
            this.averageTicketRetailGoal = averageRetailTicketItem ? averageRetailTicketItem.amount : 0;

            this.averageTicketServiceActual = averageServiceTicketItem ? averageServiceTicketItem.actualAmount : 0;
            this.averageTicketServiceGoal = averageServiceTicketItem ? averageServiceTicketItem.amount : 0;

            this.createBarChart(this.averageTicketOverallGoal, this.averageTicketOverallActual, '.average-ticket-overall');
            this.createBarChart(this.averageTicketRetailGoal, this.averageTicketRetailActual, '.average-ticket-retail');
            this.createBarChart(this.averageTicketServiceGoal, this.averageTicketServiceActual, '.average-ticket-service');
        }

        
        private isValidData(num: number): boolean {
            return (!_.isUndefined(num) && !_.isNaN(num) && !_.isNull(num) && num !== 0)
        }

        // create bar chart
        createBarChart = (numGoal: number, numActual: number, id: string) => {

            let width: number = 180;
            let height: number = 160;
            let defaultBarHeight: number = 2;
            let defaultYValue: number = height - defaultBarHeight;
            let thickness: number = 40;
            let duration: number = 800;
            let foregroundColor: string = "#72b8ff";
            let backgroundColor: string = "#ccc";
            let percent: number = numActual;
            let margin = {
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
            };
            let groupBarPadding = .2;
            let individualBarPadding = 4;
            var color = d3.scaleOrdinal([backgroundColor, foregroundColor]);

            const categories = ['goals', 'actuals'];

            let data = [
                {
                    subCategory: 'goals',
                    value: numGoal
                },
                {
                    subCategory: 'actual',
                    value: numActual
                }
            ];

            //const svg = d3.select(id);


            const selector = d3.select(id);

            if (selector.select('svg').empty()) {
                selector.append('svg')
            }


            if (selector.select('svg').empty()) {
                selector.select('svg')
                    .attr('class', 'bar-chart')
                    .attr('preserveAspectRatio', 'xMinYMin meet')
                    .attr('width', width)
                    .attr('height', height)
                    .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
            }
            else {
                selector.select('svg').selectAll('*').remove();
            }

            const x = d3.scaleBand().rangeRound([0, width]).padding(groupBarPadding);
            const y = d3.scaleLinear().rangeRound([height, 0]);

            const xAxis = d3.axisBottom(x)
                .tickValues([])
                .tickSize(0);

            // Chart placement
            selector.select('svg')
                .attr('width', width)
                .attr('height', height)
                .append('g')
                .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')


            x.domain(data.map(function (d) { return d.subCategory; }));

            y.domain([0, d3.max(data, function (d) { return d.value; })]);

            // Draw x-axis
            selector.select('svg').append('g')
                .attr('class', 'x axis')
                .attr('transform', 'translate(0, ' + height + ')')
                .call(xAxis)
                .selectAll('text')
                .attr('class', 'svg-category-label')

            // Hide label
            selector.select('svg').selectAll('.svg-category-label')
                .attr('display', 'none')

            let goalRatio: number = 0;

            if (numActual > 0) { goalRatio = (numGoal / numActual) };

            let getRectYAttr = (d: any, i: number): number => {

                if (this.isValidData(numGoal) && this.isValidData(numActual) && numGoal > 0) {
                    return y(d.value);
                }
                else if ((_.isUndefined(numGoal) && _.isUndefined(numActual)) || (_.isNull(numGoal) && _.isNull(numActual))) {
                    return defaultYValue;
                }
                // if numgoal is valid but num actual is invalid
                else if ((this.isValidData(numGoal) && !this.isValidData(numActual)) || goalRatio > 100) {
                    return i == 0 ? 0 : defaultYValue;
                }
                // if numgoal is invalid but numactual is valid
                else if ((!this.isValidData(numGoal) && this.isValidData(numActual)) || (this.isValidData(goalRatio) && (goalRatio < 0.02 && goalRatio > 0))) {
                    return i == 0 ? defaultYValue : 0;
                }
                else {
                    return defaultYValue;
                }
            }

            let getRectHeightAttr = (d: any, i: number): number => {

                if (this.isValidData(numGoal) && this.isValidData(numActual)) {
                    return height - y(d.value)

                }
                // if numgoal is valid but num actual is invalid
                else if ((this.isValidData(numGoal) && !this.isValidData(numActual)) || goalRatio > 100) {
                    return i == 0 ? height : defaultBarHeight;
                }
                // if numgoal is invalid but numactual is valid
                else if ((!this.isValidData(numGoal) && this.isValidData(numActual) && numActual > 0) || (goalRatio < 0.02 && goalRatio > 0)) {
                    return i == 0 ? defaultBarHeight : height;
                }
                else {
                    return defaultBarHeight;
                }

            }

            selector.select('svg').selectAll('rect')
                .data(data)
                .enter().append('rect')
                .attr('class', function (d, i) {
                    return i > 0 ? 'actual-bar' : 'goal-bar';
                })
                .attr('x', function (d) { return x(d.subCategory) })
                .attr('y', function (d) { return y(0) })
                .attr('width', x.bandwidth())
                .attr('fill', d => color(d.subCategory))

            // Transition animation
            selector.select('svg').selectAll('rect')
                .transition()
                .delay(200)
                .duration((d) => {
                    return d.value > 0 ? duration : 0;
                })
                .attr('y', function (d, i) {
                    return getRectYAttr(d, i);
                })
                .attr('height', function (d, i) {
                    return getRectHeightAttr(d, i);
                });

        }

    }


    angular.module('meevo.components.controls')
        .component('meevoGoalsAverageTicketChartsComponent', <angular.IComponentOptions>{
            templateUrl: 'app/components/controls/charts/goalsAverageTicketCharts/goalsAverageTicketCharts.template.html',
            controller: MeevoGoalsAverageTicketChartsComponent,
            controllerAs: 'vm',
            bindings: {
                
            },
            require: {
                parent: '^^meevoGoalsTileComponent'
            }
        });
}